module.exports = __webpack_public_path__ + "img/Frame 935.a51d28f6.svg";